export default (function (v) { return v; });
//# sourceMappingURL=identity.js.map